(() => {
  const init = () => {
    document.querySelectorAll('[data-fm-paths]').forEach(root => {
      const mode = new URLSearchParams(location.search).get('modo');
      if (!['individual', 'volumen'].includes(mode)) return;
      const key = mode === 'volumen' ? 'volume' : 'individual';
      root.querySelector('[data-fm-route-title]').textContent = root.querySelector(`[data-fm-${key}-title]`).textContent;
      root.querySelector('[data-fm-route-lead]').textContent = root.querySelector(`[data-fm-${key}-lead]`).textContent;
    });
    document.querySelectorAll('[data-fm-help]').forEach(button => button.addEventListener('click', () => {
      const launcher = document.querySelector('[data-ai-launcher]');
      if (launcher && launcher.getAttribute('aria-expanded') !== 'true') launcher.click();
    }));

  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();
